import styled from "styled-components";

const ItemReceiptsPageStyled = styled.div`

`;

export default ItemReceiptsPageStyled;